import {
  Flex,
  Text,
  type FlexProps,
  type MultiSelectProps,
} from '@mantine/core';
import { CitiesMultiSelect } from '../cities-multi-select/CitiesMultiSelect';
import classes from './FormCitiesMultiSelect.module.scss';

interface FormCitiesMultiSelectProps extends MultiSelectProps {
  title?: string;
  description?: string;
  containerProps?: FlexProps;
}

export const FormCitiesMultiSelect = ({
  title = 'Город',
  description = 'В каком городе предстоит работать',
  containerProps,
  ...props
}: FormCitiesMultiSelectProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <CitiesMultiSelect
        {...props}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
